import React from "react";

export const Heatmap = () => {
    React.useEffect(() => {
        const heatmapScript = document.createElement("script");
        heatmapScript.type = "text/javascript";
        heatmapScript.src = "https://u.heatmap.it/log.js";
        document.head.appendChild(heatmapScript);
    }, []);

    return null;
};
